export default "__VITE_ASSET__BQZAtg$n__"